import box from 'images/box.svg';
import dropbox from 'images/dropbox.svg';
import egnyte from 'images/egnyte.svg';
import google from 'images/google-drive.svg';
import onedrive from 'images/onedrive.svg';
import sharefile from 'images/sharefile@2x.png';
import sharepoint from 'images/sharepoint.svg';
import React, { ReactElement } from 'react';

const ManageConnectionIcon = (providerType: any): ReactElement => {
  switch (providerType.providerType) {
    case 'sharepoint':
      return <img src={sharepoint} alt="SharePoint Icon" />;
    case 'dropbox':
      return <img src={dropbox} alt="Dropbox Icon" />;
    case 'googledrive':
      return <img src={google} alt="Google Drive Icon" />;
    case 'citrix':
      return <img src={sharefile} alt="Citrix ShareFile Icon" width="48px" />;
    case 'box':
      return <img src={box} alt="Box Icon" />;
    case 'egnyte':
      return <img src={egnyte} alt="Egnyte Icon" />;
    case 'onedrive':
      return <img src={onedrive} alt="Onedrive Icon" />;
    default:
      return <div />;
  }
};

export default ManageConnectionIcon;
